import produce from 'immer';
import {LOADER_STATUS,SET_USER_MODULE,SET_MASTER_MODULE} from './constants';


export const initialState = {
    loaderStatus: false,
    userModules:[],
    masterModules:[]
  };


  const userModuleReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_USER_MODULE:
        return {
          ...state,
          userModules:action.userModules
        }
      case SET_MASTER_MODULE:
        return {
          ...state,
          masterModules:action.masterModules
        }
      default:
        return state;     
    }
  };

export default userModuleReducer;